export const TXTWCL_Must_be_shorter_than_N0_charac_ELL = {
  "id": "TXTWCL_Must_be_shorter_than_N0_charac_ELL",
  "defaultMessage": "Must be shorter than {0} characters"
} as const;